var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHousekeepingTickets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M59,127.8h11.7c0-12.9,10.5-23.4,23.4-23.4V92.6c-12.9,0-23.4-10.5-23.4-23.4H59 c0,12.9-10.5,23.4-23.4,23.4v11.7C48.5,104.3,59,114.8,59,127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M23.8,198.1h11.7c0-12.9,10.5-23.4,23.4-23.4V163c-12.9,0-23.4-10.5-23.4-23.4H23.8 C23.8,152.5,12.9,163,0,163v11.7C12.9,174.6,23.8,185.1,23.8,198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M190.2,134.3c3.3-9.2-1.4-19.2-10.5-22.5l-6.4-2.3c0.1-5.2-2.3-10.3-6.4-13.7L200,6l-11-4l-33.2,89.8 c-5.3,0-10.4,2.3-13.7,6.4l-6.4-2.3c-4.4-1.6-9.2-1.4-13.4,0.6c-4.3,2-7.5,5.5-9.1,9.9l-2,5.5l77.1,28.1L190.2,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M71.7,145.1l-9.7-0.9l3.7,9c2,4.9,4.6,9.5,7.6,13.8c7.4,10.6,19.3,17.5,32.6,19.1v7l4,1.3 c5.5,1.8,11,3.2,16.6,2.7c17.4,0,33.8-8.6,44-22.9c5.2-7.3,9.5-15.2,13.2-23.5l-76.6-27.9C101.7,137.3,87.1,146.5,71.7,145.1 L71.7,145.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeepingTickets);
export default __webpack_public_path__ + "static/media/Housekeeping-tickets.635be7218b2a3401d5ea4fa6d47f5bf7.svg";
export { ForwardRef as ReactComponent };